import React from 'react';
import PropTypes from 'prop-types';

import Page from '../shared/Page';
import StaticPage from '../shared/StaticPage';
import withEulaRestrictions from '../license/withEulaRestrictions';
import { getBreadCrumbs } from '../../utils/breadCrumbs';

export class SupportPage extends React.Component {
  static get propTypes() {
    return {
      title: PropTypes.string,
      location: PropTypes.object,
    };
  }

  getBreadCrumbs(title) {
    const { pathname } = this.props.location;
    return getBreadCrumbs(title, pathname, []);
  }

  render() {
    const {
      title
    } = this.props;

    return (
      <Page
        header={title}
        breadCrumbs={this.getBreadCrumbs(title)}
      >
        <StaticPage url='/content/support/index.html' />
      </Page>
    );
  }
}

export default withEulaRestrictions(SupportPage);



// WEBPACK FOOTER //
// src/components/support/SupportPage.jsx